import React from 'react'
import { makeStyles } from '@mui/styles'

import ModalBig from '../big/modal-big'
import { ButtonIconSquare } from '../../buttons'
import CheckIcon from 'assets/images/icons/check.svg'

const useStyles = makeStyles(() => ({
  dialog: {
    width: 500,
    padding: 20,
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontSize: 24,
    paddingBottom: 25,
  },
  content: {
    minHeight: 85,
  },
  actions: {
    padding: 20,
  },
}))

interface IAlertModalProps {
  open: boolean
  title: string
  children: string | React.ReactNode
  buttonLabel?: string
  dataQsId?: string
  disableEscapeKeyDown?: boolean
  disableBackdropClick?: boolean
  onConfirmClick: () => void
  onCancelClick: () => void
}

const AlertModal = (props: IAlertModalProps) => {
  const {
    open,
    title,
    children,
    buttonLabel = 'OK',
    dataQsId,
    disableEscapeKeyDown,
    disableBackdropClick,
    onConfirmClick,
    onCancelClick,
  } = props
  const classes = useStyles()

  const actions = [
    <ButtonIconSquare key='confirm' icon={CheckIcon} label={buttonLabel} onClick={onConfirmClick} />,
  ]

  return (
    <ModalBig
      open={open}
      className={classes.dialog}
      actionClass={classes.actions}
      actions={actions}
      dataQsId={dataQsId}
      onClose={onCancelClick}
      disableEscapeKeyDown={disableEscapeKeyDown}
      disableBackdropClick={disableBackdropClick}>
      <div className={classes.wrapper}>
        <div className={classes.title}>{title}</div>
        <div className={classes.content}>
          {children}
        </div>
      </div>
    </ModalBig>
  )
}

export default AlertModal
